<div class="listview container-fluid">
  <base-customer-inquiry-list-filters
    *ngIf="inquiriesLoaded"
    [qualifications]="qualifications"
    [departments]="departments"
    [createdByCustomers]="createdByCustomers"
    [filterValues]="filters"
    [canPublishInquiry]="canPublishInquiry"
  ></base-customer-inquiry-list-filters>

  <div class="listview-header">
    <div class="row">
      <div class="col-2">
        <base-sortable-headline-item
          orderKey="departmentName"
          [label]="departmentColumnLabel"
        ></base-sortable-headline-item>
      </div>
      <div class="col-2">
        <base-sortable-headline-item
          label="qualifications.singular"
          orderKey="mainQualificationName"
        ></base-sortable-headline-item>
      </div>
      <div class="col-1">
        <base-sortable-headline-item
          label="inquiry.created"
          orderKey="createdAt"
        ></base-sortable-headline-item>
      </div>
      <div class="col-2">
        <base-sortable-headline-item
          label="inquiry.period"
          orderKey="startDate"
        ></base-sortable-headline-item>
      </div>
      <div class="col-1">
        <div baseTruncate>{{ 'inquiry.serviceSupplies' | baseBusinessKey | translate }}</div>
      </div>
      <div class="col-4">
        <div class="row">
          <div class="col-4">
            <div baseTruncate>{{ 'inquiry.plural' | translate }}</div>
          </div>
          <div class="col-8">
            <base-sortable-headline-item
              class="d-inline-block"
              label="state"
              orderKey="status"
            ></base-sortable-headline-item>
          </div>
        </div>
      </div>
    </div>
  </div>

  <base-customer-inquiry-list-item
    class="d-block listview-item"
    *ngFor="let inquiry of inquiries; trackBy: trackByCustomerInquiry"
    [inquiry]="inquiry"
    [canPublishInquiry]="canPublishInquiry"
    [copiedInquiry]="copiedInquiry"
    [filters]="filters"
  ></base-customer-inquiry-list-item>

  <base-empty-list-row
    *ngIf="inquiriesLoaded && !inquiries?.length"
    message="inquiry.emptyList"
  ></base-empty-list-row>
</div>

<div class="pagination">
  <base-pagination
    [page]="page"
    [size]="size"
    [itemsCount]="itemsCount"
  ></base-pagination>
</div>
